
import React, { useEffect, useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import { Dialog, Label, Listbox, Transition, DialogTitle, DialogPanel } from '@headlessui/react';
import { useNavigate, useParams } from "react-router-dom";
import { getColorForLabel } from "../JobDetailsList";
// import ViewFeedbackQuickMode from "../../qucikMode/ViewFeedbackQuickMode";
// import { _feedback_update_item } from "../../setting/settingPages/baseAPI";


// Helper function to get local storage data
const getLocalStorageData = () => {
  const data = localStorage.getItem('baseMembersDetails');
  return data ? JSON.parse(data) : [];
};

const getLocalStorageBoards = () => {
  const data = localStorage.getItem('channelData');
  return data ? JSON.parse(data) : [];
};

const ListItem = ({ item, index }: any) => {
  // const localStorageData = getLocalStorageData();
  // const assignedMember = localStorageData.find((member: { id: any; }) => member.id === item.item_assigned_to);
  // const title = assignedMember ? assignedMember.display_name : '';

  // boards
  const localStroageBoards = getLocalStorageBoards();
  const assignBoards = localStroageBoards.find((member: { id: any; }) => member.id === item.board_id);
  const boardsName = assignBoards ? assignBoards.name : '';
  const boardsColor = assignBoards ? assignBoards.color : '';
  const navigate = useNavigate()
  const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string }>();
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];

  const taskDetails = JSON.parse(item.task_details);

  const getUserName = (userId: any) => {
    const user = baseMembers.find((member: any) => member.user_id === userId || member.user_id === Number(userId));
    return { name: user?.name || 'Unknown', profileImage: user?.profile_pic || '' };
  };

  const reviewer = getUserName(taskDetails?.assigned_to);

  const dueDate = taskDetails?.due_by ? new Date(taskDetails.due_by) : null;
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Strip time from today for accurate comparison

  const isPastDue = dueDate && dueDate < today;

  const formattedDate = dueDate
    ? dueDate.toLocaleDateString('en-US', {

      month: 'short',
      day: 'numeric',
    })
    : null;

  const formattedDateTooltip = dueDate
    ? dueDate.toLocaleDateString('en-US', {
      // year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
    : null;


  // sentiments 
  const getSentimentColor = (sentiment: string) => {
    switch (sentiment?.toLowerCase()) {
      case 'positive':
        return '#16a34a33';
      case 'negative':
        return '#dc26261a';
      case 'spam':
        return '#6b72801a';
      case 'mixed':
        return '#1d4ed81a';
      default:
        return 'transparent';
    }
  };

  const sentiment = item.item_sentiment?.trim();
  const bgColor = getSentimentColor(sentiment);

  const [selectedItemId, setSelectedItemId] = useState<any>(null)
  const [quickViewMode, setQuickViewMode] = useState(false)
  const [selectedItemType, setSelectedItemType] = useState<any>(null);

  const handleQuickMode = (itemId: any, itemType: any) => {
    setQuickViewMode(true)
    setSelectedItemId(itemId)
    setSelectedItemType(itemType);
  }

  const handleOverViewPage = (id: any) => {
    navigate(`/${baseId}/job/${jobId}/app/${id}/overview`)
  }

  return (
    <>
      <Draggable draggableId={String(item.id)} key={item.id} index={index}>
        {(provided, snapshot) => (
          <div
            className="flex items-stretch justify-stretch touch-pan-right mb-2 border border-solid border-light-gray-200 rounded-md bg-[#f9fafa]"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={{
              ...provided.draggableProps.style,
              backgroundColor: snapshot.isDragging ? "lightblue" : "#f9fafa",
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
            }}
          >
            <div className="custom-drap-drop cursor-pointer no-underline outline-none flex flex-col w-min-0 break-words
         text-dark-black-100 w-full"
              //  onClick={() => handleQuickMode(item.id, 'feedback')}
              onClick={() => handleOverViewPage(item?.id)}
            >
              <div
                className={`flex flex-col gap-[0rem] px-0 flex-1 relative ${taskDetails?.title ? 'pt-4' : 'py-4'}`}
              >
                <div className="flex flex-col justify-start px-4">
                  {/* {index} */}
                  {
                    item.item_refernce_id &&
                    <div className="flex gap-2 items-center pb-[6px]">

                      <p className="font-[500] text-[13px] text-dark-black-200 leading-4 ">{item.item_refernce_id}</p>
                    </div>
                  }




                  <div className="flex justify-between items-center">
                    <p className="font-[500] text-[13px] text-dark-black-200 leading-4 pb-[4px] line-clamp-2">
                      {item?.app_name || 'No Name'}
                    </p>
                    {
                      item?.reviewed_by === null &&
                      <span className="flex items-center gap-[6px]  text-[13px] capitalize  rounded-md bg-gray-50 px-2 py-1
                 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                        New
                      </span>
                    }


                  </div>

                  {item?.app_headline ? (
                    <span className=" text-[#000000EB]  text-[13px] leading-4 font-normal mt-1 line-clamp-1">
                      {item.app_headline}
                    </span>
                  ) : item?.app_email ? (
                    <span className=" text-[#000000EB]  text-[13px] leading-4 font-normal mt-1 line-clamp-1">
                      {item.app_email}
                    </span>
                  ) : null}


                  <div className="flex items-start gap-1">
                    <p className="text-dark-black-100 text-[13px] leading-4 font-medium "> {item.item_title}</p>
                  </div>
                </div>
                {
                  taskDetails?.title &&
                  <div className={`flex items-start flex-wrap gap-x-2 mt-[10px] mb-0 rounded-bl-md rounded-br-md py-1 px-4 ${isPastDue ? 'bg-[#fdf2f8] text-[#c6005c]' : 'bg-[#f9fafa] border-t border-solid border-[#e0e0e0]'}`}>

                    <div className='mt-[4px]'>
                      {
                        taskDetails?.type === 'review' &&
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={`icon icon-tabler icons-tabler-outline icon-tabler-devices-check w-[1rem] h-[1rem] ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}

                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4" />
                          <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7" />
                          <path d="M16 9h2" />
                          <path d="M15 19l2 2l4 -4" />
                        </svg>

                      }
                      {
                        taskDetails?.type === 'scorecard' &&
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={`icon icon-tabler icons-tabler-outline icon-tabler-scoreboard w-[1rem] h-[1rem] ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z" />
                          <path d="M12 5v2" />
                          <path d="M12 10v1" />
                          <path d="M12 14v1" />
                          <path d="M12 18v1" />
                          <path d="M7 3v2" />
                          <path d="M17 3v2" />
                          <path d="M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z" />
                          <path d="M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5" />
                        </svg>
                      }
                      {
                        taskDetails?.type === 'questionnaire' &&
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={`icon icon-tabler icons-tabler-outline icon-tabler-notebook w-[1rem] h-[1rem] ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18" />
                          <path d="M13 8l2 0" />
                          <path d="M13 12l2 0" />
                        </svg>

                      }
                      {
                        taskDetails?.type === 'meeting' &&
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className={`icon icon-tabler icons-tabler-outline icon-tabler-calendar w-[1rem] h-[1rem] ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}
                   
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" />
                          <path d="M16 3v4" />
                          <path d="M8 3v4" />
                          <path d="M4 11h16" />
                          <path d="M11 15h1" />
                          <path d="M12 15v3" />
                        </svg>


                      }
                    </div>
                    {formattedDateTooltip && (
                      <div
                      >
                        <span className={`text-[13px] ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}>
                          {formattedDateTooltip}
                        </span>
                      </div>
                    )}
                    {
                      taskDetails?.assigned_to > 0 &&
                      <div className='mt-[4px] table-tooltip-list before:!bottom-[17px] before:!left-[11px]' data-title={reviewer.name}>
                        {
                          reviewer.profileImage ? (
                            <img
                              src={`${process.env.REACT_APP_API_BASE_URL}/${reviewer.profileImage}`}
                              alt={`${'Profile'}`}
                              className="w-4 h-4 rounded-full object-cover"
                            />
                          ) : (
                            <div style={{ backgroundColor: getColorForLabel(reviewer.name?.charAt(0)) }}
                              className="w-4 h-4 rounded-full flex items-center justify-center">
                              <span className="font-medium text-white text-[11px]"
                              >{reviewer.name?.charAt(0)}</span>
                            </div>
                          )
                        }
                      </div>
                    }

                    <div className="flex flex-row gap-x-3 flex-wrap">
                      {
                        taskDetails?.title &&
                        <div
                        // className='table-tooltip-list before:!bottom-[17px] before:!left-[27px] before:!text-[11px]' data-title={taskDetails.type}
                        >
                          <span className={`text-[13px] font-normal line-clamp-2 capitalize ${isPastDue ? 'text-[#c6005c]' : 'text-[#4a5565]'}`}
                         >{taskDetails?.title}</span>
                        </div>
                      }

                    </div>

                  </div>
                }

                {/* <div className="flex items-center gap-2">
                  {
                    boardsName && boardsColor &&
                    <div className="pt-[1rem]">
                      <div className="flex items-center max-w-fit font-[500] leading-[1.2] bg-light-gray-100 rounded-full text-[0.75rem] px-[0.5rem] py-[5px] gap-2">
                        <span className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] 
                font-medium text-white capitalize" style={{ backgroundColor: boardsColor }}></span>
                        <span className="text-[#52555a] capitalize">{boardsName}</span>
                      </div>
                    </div>
                  }
                  {
                    item.item_sentiment &&
                    <div className="pt-[1rem]">
                      <div className="flex items-center max-w-fit font-[500] leading-[1.2] bg-light-gray-100 rounded-full text-[0.75rem] px-[0.5rem] py-[5px] gap-2">
                        <span className="flex h-[8px] w-[8px] shrink-0 items-center justify-center rounded-full border-none text-[0.625rem] 
                font-medium text-white capitalize" style={{ backgroundColor: bgColor }}></span>
                        <span className="text-[#52555a] capitalize">{item.item_sentiment}</span>
                      </div>
                    </div>
                  }
                  {
                    title &&
                    <div className="pt-[1rem]">
                      <div className="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[10px] table-tooltip leading-4 before:leading-4" data-title={title}>
                        <span className="text-[9px] font-medium text-gray-700">
                          {title ? title.charAt(0) : ''}
                        </span>
                      </div>
                    </div>
                  }


                </div> */}

              </div>
            </div>
          </div>
        )}
      </Draggable>


      <Dialog open={quickViewMode} onClose={setQuickViewMode} className="relative z-10">
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <DialogPanel

                className="pointer-events-auto w-screen max-w-[40rem] transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="flex h-full flex-col  bg-white py-0 shadow-xl">
                  <div className="px-0">
                    <div className="flex items-start justify-between flex-col">
                      {/* <ViewFeedbackQuickMode
                        itemId={selectedItemId}
                        isSidebarOpen={quickViewMode}
                        itemType={selectedItemType}
                        setIsSidebarOpen={setQuickViewMode} /> */}


                    </div>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>

    </>
  );
};

export default ListItem;
